import React, { useState, useEffect } from "react";
import {
  makeStyles,
  withStyles,
  Button,
  Dialog,
  Typography,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  MenuItem,
  FormControl,
  Select,
  Tooltip,
} from "@material-ui/core/";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import AddIcon from "@material-ui/icons/Add";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import { isObjectEmpty } from "../../../../utils/general";
import { addSelectClassData } from "../../../../reduxSlices/selectClassSlice";

import localizedStrings from "../../../../utils/localize";
import { arrayIncludes } from "@material-ui/pickers/_helpers/utils";
const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const useStyles = makeStyles({
  formControl: {
    color: "white",
  },
  formRoot: {
    color: "white",
  },
});

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#005598",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}))(Tooltip);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;

  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const ModalDialog = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [termsData, setTerms] = useState("");
  const [dptData, setDptData] = useState("");
  const [courseData, setCourseData] = useState("");
  const [campusData, setCampusData] = useState("");
  const [tableMapData, setTableMapData] = useState([]);

  let modalData = useSelector((state) => state.selectClassData.modalData);
  const selectClassData = useSelector(
    (state) => state.selectClassData.selectClassData,
  );
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChange = (event) => {
    const copyTableMapData = [...modalData];
    if (event.target.name === "term") {
      if (event.target.value?.length === 0) {
        setTableMapData(copyTableMapData);
      } else {
        let copyData = copyTableMapData.filter(
          (element) => element.ses_termname === event.target.value,
        );
        setTableMapData(copyData);
      }

      setTerms(event.target.value);
      setDptData("");
      setCourseData("");
      setCampusData("");
    }
    if (event.target.name === "dept") {
      if (event.target.value?.length === 0) {
        setTableMapData(copyTableMapData);
      } else {
        let copyData = copyTableMapData.filter(
          (element) => element.ses_departmentname === event.target.value,
        );
        setTableMapData(copyData);
      }

      setDptData(event.target.value);
      setTerms("");
      setCourseData("");
      setCampusData("");
    }
    if (event.target.name === "course") {
      if (event.target.value?.length === 0) {
        setTableMapData(copyTableMapData);
      } else {
        let copyData = copyTableMapData.filter(
          (element) => element.ses_coursename === event.target.value,
        );
        setTableMapData(copyData);
      }

      setCourseData(event.target.value);
      setDptData("");
      setTerms("");
      setCampusData("");
    }
    if (event.target.name === "campus") {
      if (event.target.value?.length === 0) {
        setTableMapData(copyTableMapData);
      } else {
        let copyData = copyTableMapData.filter(
          (element) => element.ses_campusname === event.target.value,
        );
        setTableMapData(copyData);
      }

      setCampusData(event.target.value);
      setCourseData("");
      setDptData("");
      setTerms("");
    }
  };

  const handleAddData = (id) => {
    if (id != undefined) {
      if (isObjectEmpty(selectClassData.find((data) => data.id === id))) {
        const copyTableMapData = [...tableMapData];
        dispatch(
          addSelectClassData(copyTableMapData.find((data) => data.id === id)),
        );
      }
    }
    props.handleClose();
  };

  const removeDuplicateFromObjects = (objectArray, field) => {
    if (objectArray?.length > 0) {
      if (field === "termName")
        return objectArray.filter(
          (v, i, a) =>
            a.findIndex((t) => t.ses_termname === v.ses_termname) === i,
        );
      else if (field === "dept")
        return objectArray.filter(
          (v, i, a) =>
            a.findIndex(
              (t) => t.ses_departmentname === v.ses_departmentname,
            ) === i,
        );
      else if (field === "course")
        return objectArray.filter(
          (v, i, a) =>
            a.findIndex((t) => t.ses_coursename === v.ses_coursename) === i,
        );
      else if (field === "campus")
        return objectArray.filter(
          (v, i, a) =>
            a.findIndex((t) => t.ses_campusname === v.ses_campusname) === i,
        );
    }
    return [];
  };

  useEffect(() => {
    if (!isObjectEmpty(modalData)) {
      const removeEmptyObjmodalData = modalData?.filter(
        (value) => Object.keys(value).length !== 0,
      );
      setTableMapData(removeEmptyObjmodalData);
    }
  }, [modalData]);

  //current lagnguage
  const language = useSelector((state) => state.language.language);
  //set the current language to localize string
  localizedStrings.setLanguage(language);

  function sorter(arr) {
    let array = arr.sort(function (a, b) {
      if (a.props.value != null) {
        return a.props.value.localeCompare(b.props.value);
      } else if (b.props.value != null) {
        return b.props.value.localeCompare(a.props.value);
      }
    });
    return array;
  }
  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);

  let tableData = "";
  let termData = "";
  let deptsData = "";
  let coursesData = "";
  let campusesData = "";

  if (!isObjectEmpty(modalData)) {
    if (modalData) {
      if (Array.isArray(modalData)) {
        modalData = modalData?.filter(
          (value) => Object.keys(value).length !== 0,
        );

        tableData =
          tableMapData?.length > 0
            ? tableMapData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((element, index) => {
                  return (
                    <StyledTableRow key={index}>
                      <StyledTableCell component="th" scope="row">
                        <HtmlTooltip
                          title={
                            <React.Fragment>
                              <Typography
                                component="body"
                                style={{ fontSize: "0.75rem" }}
                              >
                                {
                                  localizedStrings.students.selectClasses
                                    .modalTable.department
                                }{" "}
                                - {element.ses_departmentname}
                              </Typography>
                              <Typography
                                component="body"
                                style={{ fontSize: "0.75rem" }}
                              >
                                {
                                  localizedStrings.students.selectClasses
                                    .modalTable.course
                                }{" "}
                                - {element.ses_coursename}
                              </Typography>
                              <Typography
                                component="body"
                                style={{ fontSize: "0.75rem" }}
                              >
                                {
                                  localizedStrings.students.selectClasses
                                    .modalTable.class
                                }{" "}
                                - {element.ses_class}
                              </Typography>
                              <Typography
                                component="body"
                                style={{ fontSize: "0.75rem" }}
                              >
                                {
                                  localizedStrings.students.selectClasses
                                    .modalTable.credits
                                }{" "}
                                -{" "}
                                {element.ses_creditsavailable ===
                                (null || undefined || "")
                                  ? ""
                                  : element.ses_creditsavailable}
                              </Typography>
                              <Typography
                                component="body"
                                style={{ fontSize: "0.75rem" }}
                              >
                                {
                                  localizedStrings.students.selectClasses
                                    .modalTable.rooms
                                }{" "}
                                - {element.ses_roomname}
                              </Typography>
                              <Typography
                                component="body"
                                style={{ fontSize: "0.75rem" }}
                              >
                                {
                                  localizedStrings.students.selectClasses
                                    .modalTable.startDate
                                }{" "}
                                - {element.ses_startdate}
                              </Typography>
                              <Typography
                                component="body"
                                style={{ fontSize: "0.75rem" }}
                              >
                                {
                                  localizedStrings.students.selectClasses
                                    .modalTable.endDate
                                }{" "}
                                - {element.ses_enddate}
                              </Typography>
                            </React.Fragment>
                          }
                        >
                          <Button>
                            {element.ses_termname === undefined
                              ? ""
                              : element.ses_termname}{" "}
                          </Button>
                        </HtmlTooltip>
                      </StyledTableCell>
                      <StyledTableCell>
                        {element.ses_departmentname === undefined
                          ? ""
                          : element.ses_departmentname}
                      </StyledTableCell>
                      <StyledTableCell>
                        <HtmlTooltip
                          title={
                            <React.Fragment>
                              <Typography
                                component="body"
                                style={{ fontSize: "0.75rem" }}
                              >
                                {
                                  localizedStrings.students.selectClasses
                                    .description
                                }{" "}
                                - {element.ses_longdescription}
                              </Typography>
                            </React.Fragment>
                          }
                        >
                          <Button style={{ textAlign: "left" }}>
                            {element.ses_course === undefined
                              ? ""
                              : ` ${element?.ses_course}- ${element?.ses_classname}`}
                            <br />
                            {element.ses_campusname === undefined
                              ? ""
                              : `${element?.ses_campusname}`}{" "}
                            {element?.ses_campusname && element?.ses_roomname
                              ? "-"
                              : element?.ses_roomname === null &&
                                  element?.ses_campusname === null
                                ? "-"
                                : ""}
                            {element?.ses_roomname === undefined
                              ? ""
                              : `${element?.ses_roomname}`}
                          </Button>
                        </HtmlTooltip>
                      </StyledTableCell>
                      <StyledTableCell>
                        {element.ses_campusname === undefined
                          ? ""
                          : element.ses_campusname}
                      </StyledTableCell>
                      <StyledTableCell>
                        {element.facultyName?.length > 0
                          ? element.facultyName.map((e, index) => (
                              <Typography variant="body2" display="block">
                                {e.ses_facultyname}
                                {e.ses_facultyname !== null &&
                                element.facultyName?.length > 1 &&
                                element.facultyName?.length - index !== 1
                                  ? `,`
                                  : null}
                              </Typography>
                            ))
                          : null}
                      </StyledTableCell>
                      <StyledTableCell>
                        {element.ses_creditsavailable
                          ? element.ses_creditsavailable.toFixed(2)
                          : ""}
                      </StyledTableCell>

                      <StyledTableCell>
                        {element?.numberEnrolled &&
                        element?.numberEnrolled != (undefined && null)
                          ? element?.numberEnrolled
                          : 0}
                        /
                        {element?.ses_classcapacity &&
                        element?.ses_classcapacity != (undefined && null)
                          ? element?.ses_classcapacity
                          : 0}
                      </StyledTableCell>
                      <StyledTableCell>{element.ses_startdate}</StyledTableCell>
                      <StyledTableCell>
                        {element.currencySymbol}
                        {element.price}
                      </StyledTableCell>
                      <StyledTableCell>
                        <Button
                          variant="outlined"
                          color="primary"
                          startIcon={<AddIcon />}
                          style={{ textTransform: "capitalize" }}
                          onClick={() => handleAddData(element.id)}
                        >
                          {
                            localizedStrings.students.selectClasses.modalTable
                              .add
                          }
                        </Button>
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })
            : null;

        termData = removeDuplicateFromObjects(modalData, "termName").map(
          (element, index) => (
            <MenuItem value={element.ses_termname} key={index}>
              {element.ses_termname}
            </MenuItem>
          ),
        );

        deptsData = removeDuplicateFromObjects(modalData, "dept").map(
          (element, index) => (
            <MenuItem value={element.ses_departmentname} key={index}>
              {element.ses_departmentname}
            </MenuItem>
          ),
        );
        deptsData = sorter(deptsData);

        coursesData = removeDuplicateFromObjects(modalData, "course").map(
          (element, index) => (
            <MenuItem value={element.ses_coursename} key={index}>
              {` ${element.ses_course}- ${element.ses_coursename}`}
            </MenuItem>
          ),
        );

        coursesData.sort(function (a, b) {
          return a.props.children.localeCompare(b.props.children);
        });

        campusesData = removeDuplicateFromObjects(modalData, "campus").map(
          (element, index) => (
            <MenuItem
              value={
                element.ses_campusname != "" ? element.ses_campusname : null
              }
              key={index}
            >
              {element.ses_campusname != undefined &&
                `${element.ses_campusname}`}
            </MenuItem>
          ),
        );
        campusesData = sorter(campusesData);
      }
    }
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Dialog
      onClose={props.handleClose}
      aria-labelledby="customized-dialog-title"
      open={props.open}
      fullWidth
      maxWidth="lg"
    >
      <DialogTitle id="customized-dialog-title" onClose={props.handleClose}>
        Available Classes
      </DialogTitle>
      <DialogContent dividers>
        <TableContainer
          component={Paper}
          style={{ minHeight: "40vh", marginBottom: "10px" }}
        >
          <Table aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell className={classes.formRoot}>
                  <span>
                    {localizedStrings.students.selectClasses.modalTable.term}
                  </span>
                  <br />
                  <FormControl className={classes.formControl}>
                    <Select
                      value={termsData}
                      onChange={handleChange}
                      className={classes.formControl}
                      displayEmpty
                      name="term"
                    >
                      <MenuItem value="">
                        {" "}
                        {
                          localizedStrings.students.selectClasses.modalTable
                            .allTerms
                        }
                      </MenuItem>
                      {termData}
                    </Select>
                  </FormControl>
                </StyledTableCell>
                <StyledTableCell>
                  {
                    localizedStrings.students.selectClasses.modalTable
                      .department
                  }
                  <FormControl className={classes.formControl}>
                    <Select
                      value={dptData}
                      onChange={handleChange}
                      className={classes.formControl}
                      displayEmpty
                      name="dept"
                    >
                      <MenuItem value="">
                        {
                          localizedStrings.students.selectClasses.modalTable
                            .allDepartments
                        }
                      </MenuItem>
                      {deptsData}
                    </Select>
                  </FormControl>
                </StyledTableCell>
                <StyledTableCell>
                  {localizedStrings.students.selectClasses.modalTable.course}
                  <FormControl
                    className={classes.formControl}
                    style={{ display: "flex" }}
                  >
                    <Select
                      value={courseData}
                      onChange={handleChange}
                      className={classes.formControl}
                      displayEmpty
                      name="course"
                    >
                      <MenuItem value="">
                        {
                          localizedStrings.students.selectClasses.modalTable
                            .allCourses
                        }
                      </MenuItem>
                      {coursesData}
                    </Select>
                  </FormControl>
                </StyledTableCell>
                <StyledTableCell>
                  {localizedStrings.students.selectClasses.modalTable.campus}
                  <FormControl
                    className={classes.formControl}
                    style={{ display: "flex" }}
                  >
                    <Select
                      value={campusData}
                      onChange={handleChange}
                      className={classes.formControl}
                      displayEmpty
                      name="campus"
                    >
                      <MenuItem value="">
                        {
                          localizedStrings.students.selectClasses.modalTable
                            .allCampuses
                        }
                      </MenuItem>
                      {campusesData}
                    </Select>
                  </FormControl>
                </StyledTableCell>
                <StyledTableCell>
                  {localizedStrings.students.selectClasses.modalTable.faculty}
                </StyledTableCell>
                <StyledTableCell>
                  {localizedStrings.students.selectClasses.modalTable.credits}
                </StyledTableCell>
                <StyledTableCell>
                  {localizedStrings.students.selectClasses.modalTable.enrolled}
                </StyledTableCell>
                <StyledTableCell>
                  {localizedStrings.students.selectClasses.modalTable.firstMeet}
                </StyledTableCell>
                <StyledTableCell>
                  {localizedStrings.students.selectClasses.modalTable.price}
                </StyledTableCell>
                <StyledTableCell>
                  {localizedStrings.students.selectClasses.modalTable.actions}
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>{tableData}</TableBody>
          </Table>
          <TablePagination
            style={{ textTransform: "capitalize" }}
            rowsPerPageOptions={[5, 10, 25, 100]}
            component="div"
            count={tableMapData?.length > 0 ? tableMapData?.length : 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={props.handleClose} color="primary">
          {localizedStrings.students.selectClasses.modalTable.close}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalDialog;
